<template>
  <div name="logical-statement-popup" id="logical-statement-popup" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header header-popup clearfix">
          <button type="button" class="close" data-dismiss="modal" >&times;</button>
          <h4 class="modal-title"></h4>
        </div>

        <div class="modal-body detail detail-responsive clearfix" style="margin-top: 0"> 
          <div class="logical-wrapper">
            <div class="title">Condition</div>
            <lists    :nowLang="nowLang"
                      :labelCodsex="labelCodsex"
                      :lists="lists"
                      :listFields="listFields"
                      :listConjunctions="listConjunctions"
                      :listOperators="listOperators"
                      :findValueType="findValueType"
                      :findInputType="findInputType"
                      :findLovType="findLovType"
                      :setDescConjAndDescStmt="setDescConjAndDescStmt"
                      :viewList="viewList"
                      :editList="editList"
                      :deleteList="deleteList"
                      :linkList="linkList"
                      :unlinkList="unlinkList"
                      :groupList="groupList"
                      :ungroupList="ungroupList"
                      :totalLink="totalLink"
                      @setLists="setLists(arguments[0])" />
            <add-list :rootNode="lists.length === 0"
                      :totalLists="lists.length"
                      :totalEdit="totalEdit"
                      :labelCodsex="labelCodsex"
                      :list="list"
                      :listDisp="listDisp"
                      :objConj="objConj"
                      :listFields="listFields"
                      :listConjunctions="listConjunctions"
                      :listOperators="listOperators"
                      :nowLang="nowLang"
                      :addList="addList"
                      :resetLists="resetLists"
                      :back="back"
                      :submit="submit"
                      :findValueType="findValueType"
                      :findInputType="findInputType"
                      :findLovType="findLovType"
                      :showAddList="showAddList"
                      :validStmt="validStmt" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import lists from 'components/hrmsLogicalStatement/lists'
  import addList from 'components/hrmsLogicalStatement/addList'

  export default {
    name: 'logical-statement-popup',
    methods: {
      setLists (myLists) {
        this.$emit('setLists', myLists)
      }
    },
    props: {
      labelCodsex: {
        type: Object
      },
      lists: {
        type: Array,
        required: true
      },
      listFields: {
        type: Array,
        required: true
      },
      listConjunctions: {
        type: Object,
        required: true
      },
      listOperators: {
        type: Array,
        required: true
      },
      nowLang: {
        type: String,
        default: 'th'
      },
      viewList: {
        type: Function
      },
      editList: {
        type: Function
      },
      deleteList: {
        type: Function
      },
      setDescConjAndDescStmt: {
        type: Function
      },
      linkList: {
        type: Function
      },
      unlinkList: {
        type: Function
      },
      groupList: {
        type: Function
      },
      ungroupList: {
        type: Function
      },
      totalEdit: {
        type: Number
      },
      totalLink: {
        type: Number
      },
      validStmt: {
        type: Boolean,
        default: true
      },
      rootNode: {
        type: Boolean
      },
      list: {
        type: Object,
        default () {
          return {
            field: '',
            operator: '',
            value: ''
          }
        }
      },
      listDisp: {
        type: Boolean,
        defaul: false
      },
      objConj: {
        type: Object,
        default: ''
      },
      addList: {
        type: Function
      },
      resetLists: {
        type: Function
      },
      back: {
        type: Function
      },
      submit: {
        type: Function
      },
      findValueType: {
        type: Function
      },
      findInputType: {
        type: Function
      },
      findLovType: {
        type: Function
      },
      showAddList: {
        type: Function
      }
    },
    components: {
      lists,
      addList
    }
  }
</script>



// WEBPACK FOOTER //
// popup.vue?e2d6c7d0